import React from "react";
import "./CTA.css";
import { resolveStoreBadges } from "../../utils/storeLinks";

import image3Avif from "../../assets/iMockup-1.avif";
import image3Webp from "../../assets/iMockup-1.webp";
import image3Png from "../../assets/iMockup-1.png";
import image4Avif from "../../assets/iMockup-2.avif";
import image4Webp from "../../assets/iMockup-2.webp";
import image4Png from "../../assets/iMockup-2.png";

const STORE_BADGES = [
  {
    name: "App Store",
    href: "https://apps.apple.com/ng/app/okiri-mobile/id6760467395",
    img: "https://api.iconify.design/mdi:apple.svg?color=%23000&height=46",
    alt: "Download Okiri on the App Store",
  },
  {
    name: "Palm Store",
    href: null,
    img: "https://api.iconify.design/arcticons:palmstore.svg?color=%23000&height=46",
    alt: "Download Okiri from Palm Store",
  },

  {
    name: "Samsung Galaxy Store",
    href: "https://apps.samsung.com/appquery/appDetail.as?appId=com.okirimobile.app&source=GBadge_01_8741821_tag&directOpen=true&ads=ddb0e6f9&nonOrgType=fce692ba",
    img: "https://commons.wikimedia.org/wiki/Special:FilePath/Galaxy%20store%20logo.png",
    alt: "Download Okiri from Samsung Galaxy Store",
  },
  {
    name: "APKPure",
    href: "https://apkpure.com/p/com.okirimobile.app",
    img: "https://static.apkpures.xyz/www/static/imgs/logo_new@2x.png",
    alt: "Download Okiri APK from APKPure",
  },
];

function CTA() {
  const storeBadges = resolveStoreBadges(STORE_BADGES);

  return (
    <section className="cta">
      {/* Left Side */}
      <div className="cta__left">
        <h1>
          Your First Paid
          <br /> Call Awaits
        </h1>

        <p>
          Start earning from your calls—join
          <br />
          OKIRI and elevate your calling
          <br />
          experience.
        </p>

        <div className="cta__images--horizontal">
          {storeBadges.map((s) => {
            const badge = (
              <span className="cta__storeItemInner">
                <img
                  src={s.img}
                  alt={s.alt || s.name}
                  loading="lazy"
                  className="cta__storeBadge"
                  onError={(e) => {
                    e.currentTarget.onerror = null;

                    if (s.name === "Huawei AppGallery") {
                      e.currentTarget.src =
                        "https://commons.wikimedia.org/wiki/Special:FilePath/HUAWEI%20AppGallery.png";
                    }

                    if (s.name === "Samsung Galaxy Store") {
                      e.currentTarget.src =
                        "https://commons.wikimedia.org/wiki/Special:FilePath/Samsung%20Galaxy%20Store%20logo.svg";
                    }

                    // if still failing, hide
                    e.currentTarget.style.display = "none";
                  }}
                />
                <span className="cta__storeLabel">
                  {s.name}
                  {s.comingSoon ? <span className="cta__soon"> • Soon</span> : null}
                  {s.recommended ? (
                    <span
                      style={{
                        display: "block", width: "fit-content", marginTop: 4, padding: "1px 6px",
                        borderRadius: 999, fontSize: "0.7em", fontWeight: 700,
                        background: "#7c5cff", color: "#fff", whiteSpace: "nowrap",
                      }}
                    >
                      ★ For your device
                    </span>
                  ) : null}
                </span>
              </span>
            );

            if (s.href) {
              return (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.recommended ? `${s.name} — recommended for your device` : s.name}
                  className="cta__storeLink"
                  title={s.name}
                >
                  {badge}
                </a>
              );
            }

            if (s.comingSoon) {
              return (
                <span
                  key={s.name}
                  className="cta__storeLink comingSoon"
                  aria-label={s.name}
                  title="Coming to this store soon"
                >
                  {badge}
                </span>
              );
            }

            return (
              <span key={s.name} className="cta__storeLink disabled" aria-label={s.name} title={s.name}>
                {badge}
              </span>
            );
          })}
        </div>
      </div>

      {/* Right Side */}
      <div className="cta__right">
        <div className="cta__images--overlap">
          <picture>
            <source type="image/avif" srcSet={image3Avif} />
            <source type="image/webp" srcSet={image3Webp} />
            <img
              src={image3Png}
              alt="Okiri call screen mockup"
              className="cta__image--overlap-left"
              loading="lazy"
              decoding="async"
              width="640"
              height="1386"
            />
          </picture>

          <picture>
            <source type="image/avif" srcSet={image4Avif} />
            <source type="image/webp" srcSet={image4Webp} />
            <img
              src={image4Png}
              alt="Okiri wallet and earnings mockup"
              className="cta__image--overlap-right"
              loading="lazy"
              decoding="async"
              width="640"
              height="1386"
            />
          </picture>
        </div>
      </div>
    </section>
  );
}

export default CTA;


